export default {
  getActiveStickySearchBar: (state) => () => {
    return state.activeStickySearchBar
  },
  getHotel: (state) => () => {
    return state.hotel
  },
  getSearchSelected: (state) => (key) => {
    return key ? state.searchSelected[key] : state.searchSelected
  },
  getSearchQuerySearch: (state) => (key) => {
    return key ? state.querySearch[key] : state.querySearch
  },
  getErrors: (state) => () => {
    return state.errors
  },
  getResultsForCity: (state) => (city) => {
    if (state.searchResults) {
      return state.searchResults.find((item) => item.type === 4 && item.city === city)
    }
  }
}
